import { createIcon } from '@chakra-ui/icon'

export const ReportDataIcon = createIcon({
  displayName: 'ReportDataIcon',
  viewBox: '0 0 32 32',
  path: (
    <>
      <path
        fill="currentColor"
        d="M15 20h2v4h-2zm5-2h2v6h-2zm-10-4h2v10h-2z"
      />
      <path
        fill="currentColor"
        d="M25 5h-3V4a2 2 0 0 0-2-2h-8a2 2 0 0 0-2 2v1H7a2 2 0 0 0-2 2v21a2 2 0 0 0 2 2h18a2 2 0 0 0 2-2V7a2 2 0 0 0-2-2M12 4h8v4h-8Zm13 24H7V7h3v3h12V7h3Z"
      />
    </>
  ),
})
